import React from 'react';
import { GridItem } from '@nike/nike-design-system-components';
import '@nike/nike-design-tokens/dist/css/tokens.css';
import { ButtonContainerProps } from '../../types/ButtonContainerProps';
import styled from '@emotion/styled';

const StyledGridItem = styled(GridItem)`
  padding-bottom: var(--podium-cds-size-spacing-xxxxl);
`;

const ButtonContainer: React.FC<ButtonContainerProps> = ({ xs, justifySelf, children }) => {
  return <StyledGridItem xs={xs} justifySelf={justifySelf}>{children}</StyledGridItem>;
};

export default ButtonContainer;
